import React, { Component } from 'react';
import Menu from '../menu';
import { SettingsMenuBuilder } from './SettingsMenuBuilder';

const { ActionType, ItemType, MenuPanel } = Menu;

class SettingsLeftMenu extends Component {
	constructor(props) {
		super(props);

		this.state = {
			menuItems: [],
		};
	}

	componentDidMount() {
		const { activeTab } = this.props;

		this.setState({
			menuItems: SettingsMenuBuilder(activeTab),
		});
	}

	onActionTrigger = (actionType, itemType, data) => {
		const { menuItems } = this.state;
		const { showTabContent } = this.props;
		const { id, groupId, tabId } = data;

		if (actionType === ActionType.Click && itemType === ItemType.Badge) {
			this.setState({
				menuItems: menuItems.map(groupItem => {
					const { items } = groupItem;
					// highlight the group of the selected child item
					groupItem.active = groupItem.id === groupId;

					// expand the group of the selected child item
					groupItem.collapsed = groupItem.id !== groupId;

					// highlight the selected child item
					items.forEach(badgeItem => {
						badgeItem.active = badgeItem.id === id;
					});

					return groupItem;
				}),
			});

			// pass tabId to SettingsModal to render in SettingsContent
			showTabContent(tabId);
		}
	};

	render() {
		const { menuItems } = this.state;

		return (
			<div className="settings-left-menu">
				<MenuPanel items={menuItems} onActionTrigger={this.onActionTrigger} />
			</div>
		);
	}
}

export default SettingsLeftMenu;
